import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface Feedback {
  response: string
  hireStatus: string
}

interface MessageQueue {
  type: string
  message: string
}

export enum SQLJudgeActiveStage {
  testInstructions = "test-instructions",
  interviewSetup = "interview-setup",
  sqlQuery = "sql-query-test",
  sqlTheory = "sql-theory-test",
  sqlDiagram = "sql-schema-test",
  continueSession = "continue-session",
  disqualification = "disqualification",
  review = "review",
}

export const SQL_STAGE_MAP: Record<string, SQLJudgeActiveStage> = {
  "sql-query-test": SQLJudgeActiveStage.sqlQuery,
  "sql-theory-test": SQLJudgeActiveStage.sqlTheory,
  "sql-schema-test": SQLJudgeActiveStage.sqlDiagram,
}

interface SQLJudgeState {
  activeStage: SQLJudgeActiveStage
  sqlEditorValue: string
  isUserSpeaking: boolean
  feedback: Feedback | null
  sessionId: string | null
  messageQueue: MessageQueue[]
  problemDescription: string
}

const initialState: SQLJudgeState = {
  activeStage: SQLJudgeActiveStage.testInstructions,
  sqlEditorValue: "",
  feedback: null,
  isUserSpeaking: false,
  sessionId: null,
  messageQueue: [],
  problemDescription: "",
}

const SQLJudgeSlice = createSlice({
  name: "sql-judge",
  initialState,
  reducers: {
    setActiveStage: (state, action: PayloadAction<SQLJudgeActiveStage>) => {
      state.activeStage = action.payload
    },
    setSQLEditorValue: (state, action: PayloadAction<string>) => {
      state.sqlEditorValue = action.payload
    },
    setFeedback: (state, action: PayloadAction<Feedback>) => {
      state.feedback = action.payload
    },
    setIsUserSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isUserSpeaking = action.payload
    },
    setSessionId: (state, action: PayloadAction<string | null>) => {
      state.sessionId = action.payload
    },
    setMessageQueue: (state, action: PayloadAction<MessageQueue[]>) => {
      state.messageQueue = action.payload
    },
    setProblemDescription: (state, action: PayloadAction<string>) => {
      state.problemDescription = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setMessageQueue,
  setSQLEditorValue,
  setFeedback,
  setSessionId,
  setIsUserSpeaking,
  setActiveStage,
  setProblemDescription,
  resetState,
} = SQLJudgeSlice.actions

export default SQLJudgeSlice.reducer
